import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const DefaultSeoStrategy = createSimplePageStrategy('default', 'default', '/');
